module.exports = __webpack_public_path__ + "img/GY.8c63e14b.png";